export function GetNavIcones(props, messages) {

	if (props.quantAcordos > 99) {
		props.quantAcordos = '99+';
	}
	if (props.totalCertificadosPendentes > 99) {
		props.totalCertificadosPendentes = '99+';
	}
	if (props.totalMateriaisavencer > 99) {
		props.totalMateriaisavencer = '99+';
	}
	if (props.totalMensagens > 99) {
		props.totalMensagens = '99+';
	}

	return [
		{
			name: messages['menu.newReport'],
			id: 7,
			icone: 'mv-basico-novo',
			onClick: () => {},
		},
		{
			name: messages['menu.start'],
			id: 1,
			icone: 'mv-basico-casa',
			onClick: () => {
				props.history.push('/');
			},
		},
		{
			name: messages['menu.integratesoul'],
			id: 5,
			icone: 'mv-basico-consulta',
			onClick: (e) => e,
		},
		{
			name: messages['menu.serviceagreement'],
			id: 6,
			badge: props.quantAcordos,
			icone: 'mv-basico-historico',
			onClick: () => {},
		},
		{
			name: messages['menu.certification'],
			id: 2,
			badge: props.totalCertificadosPendentes,
			icone: 'mv-basico-certificado_digital_pendente',
			onClick: () => {},
		},
		{
			name: messages['menu.discardMaterial'],
			id: 3,
			badge: props.totalMateriaisavencer,
			icone: 'mv-basico-excluir',
			onClick: () => {
				props.history.push('/descarte-material');
			},
		},
		{
			name: messages['menu.messages'],
			id: 4,
			badge: props.totalMensagens,
			icone: 'mv-basico-notificacao',
			onClick: () => {
				props.mudarStatusModalMensagem();
			},
		},
	];
}



// WEBPACK FOOTER //
// ./src/componentes/nav/navIcones.js